const Footer = () => {
  return (
    <footer className="mt-4 border-t border-light-border-default bg-white text-sm text-left transition-colors duration-200 dark:border-brand-border-default dark:bg-brand-surface md:mt-6">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-4 md:gap-5 md:py-5">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] md:gap-6">
          <div className="space-y-1.5">
            <p className="font-medium text-light-text-primary dark:text-brand-text-primary">
              OAKYVERSE
            </p>
            <p className="leading-[1.45] text-light-text-secondary dark:text-brand-text-secondary">
              where tech meets adrenaline
            </p>

            <div className="space-y-1.5 pt-0.5">
              <p className="text-light-text-secondary dark:text-brand-text-secondary">
                Kampala, Uganda
              </p>
              <a
                href="tel:+256708906955"
                className="inline-flex items-center gap-2 text-light-text-secondary transition hover:text-light-accent-red dark:text-brand-text-secondary dark:hover:text-brand-accent-red"
              >
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.63 2.62a2 2 0 0 1-.45 2.11L8 9.91a16 16 0 0 0 6.09 6.09l1.46-1.29a2 2 0 0 1 2.11-.45c.84.3 1.72.51 2.62.63A2 2 0 0 1 22 16.92z" />
                </svg>
                +256708906955
              </a>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 md:justify-self-end">
            <a
              href="https://www.instagram.com/oakyverse"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-light-text-secondary transition hover:text-light-accent-red dark:text-brand-text-secondary dark:hover:text-brand-accent-red"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M16 11.37a4 4 0 1 1-3.37-3.37 4 4 0 0 1 3.37 3.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              oakyverse
            </a>

            <a
              href="https://www.tiktok.com/@oakyverse"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-light-text-secondary transition hover:text-light-accent-red dark:text-brand-text-secondary dark:hover:text-brand-accent-red"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M14.75 3c.36 1.9 1.53 3.49 3.18 4.39.98.54 2.08.81 3.17.81v3.39a8.62 8.62 0 0 1-3.26-.65 9.02 9.02 0 0 1-2.8-1.76v6.08c0 1.57-.62 3.07-1.74 4.18A5.9 5.9 0 0 1 9.11 21a5.9 5.9 0 0 1-4.18-1.73A5.9 5.9 0 0 1 3.2 15.1a5.9 5.9 0 0 1 1.73-4.18 5.9 5.9 0 0 1 4.18-1.74c.33 0 .66.03.98.08v3.48a2.46 2.46 0 0 0-.98-.2 2.55 2.55 0 0 0-2.56 2.56c0 .68.27 1.33.75 1.81.48.48 1.13.75 1.81.75a2.56 2.56 0 0 0 2.55-2.56V3h3.09z" />
              </svg>
              oakyverse
            </a>
          </div>
        </div>

        <div className="border-t border-light-border-default pt-3 dark:border-brand-border-default">
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-2 text-center md:flex-row md:items-center md:justify-between md:text-left">
              <p className="text-light-text-primary dark:text-brand-text-primary">
                © {new Date().getFullYear()} Oakley Glasses Uganda. All rights reserved.
              </p>

              <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-light-text-secondary dark:text-brand-text-secondary md:justify-end">
                <a href="#about" className="transition hover:text-light-accent-red dark:hover:text-brand-accent-red">
                  About
                </a>
                <a href="#contact" className="transition hover:text-light-accent-red dark:hover:text-brand-accent-red">
                  Contact
                </a>
                <a href="#policy" className="transition hover:text-light-accent-red dark:hover:text-brand-accent-red">
                  Privacy Policy
                </a>
              </nav>
            </div>

            <div className="text-center">
              <a
                href="https://mhussein.vercel.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-light-text-muted transition hover:text-light-accent-red dark:text-brand-text-muted dark:hover:text-brand-accent-red"
              >
                Web-store built by Web Developer Uganda
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
